import * as React from 'react';
import { useSelector } from 'react-redux';

import { CompareButtonOnboarding } from './CompareButtonOnboarding';
import { CompareButtonWithTooltip } from './CompareButtonWithTooltip';
import { COMPARE_ENABLED_CONFIG } from './constants';
import { trackAddNewbuildingToComparison, trackRemoveNewbuildingFromComparison } from './tracking';
import { useCompareOnboarding } from './useCompareOnboarding';
import { getNewbuildingId } from 'shared/selectors/newbuildingHeader';
import { useApplicationContext } from 'shared/utils/applicationContext';

interface INewbuildingHeaderCompareButtonProps {
  withOnboarding?: boolean;
}

export const NewbuildingHeaderCompareButton: React.FC<INewbuildingHeaderCompareButtonProps> = ({
  withOnboarding = false,
}) => {
  const { config } = useApplicationContext();
  const newbuildingId = useSelector(getNewbuildingId) as number;
  const [isAdded, setIsAdded] = React.useState(false);
  const isCompareEnabled = config.get<boolean>(COMPARE_ENABLED_CONFIG) || false;

  const { open, closeHandler } = useCompareOnboarding(withOnboarding && isCompareEnabled);

  const handleClick = React.useCallback(() => {
    const nextValue = !isAdded;

    setIsAdded(nextValue);

    if (nextValue) {
      trackAddNewbuildingToComparison(newbuildingId);
    } else {
      trackRemoveNewbuildingFromComparison(newbuildingId);
    }
  }, [isAdded, newbuildingId]);

  if (!isCompareEnabled) {
    return null;
  }

  if (!withOnboarding || !open) {
    return <CompareButtonWithTooltip isAdded={isAdded} onClick={handleClick} />;
  }

  return (
    <CompareButtonOnboarding open={open} onClose={closeHandler}>
      <CompareButtonWithTooltip disabled={true} isAdded={isAdded} onClick={handleClick} />
    </CompareButtonOnboarding>
  );
};
